export default "__VITE_ASSET__BKw7QOgL__"